(function() { window.GUID_af5c18de_51b5_4892_907a_a6d3309914e3 = { getGuid: function() { return "af5c18de-51b5-4892-907a-a6d3309914e3"; } }; })();
var CS;
(function (CS) {
    /** This class is only to have a common point between Views and Controls */
    class CSInstanceBase {
        constructor() {
            this.uniqueInstanceId = CS.Controls.GetNewInstanceId();
        }
        get UniqueInstanceId() {
            return this.uniqueInstanceId;
        }
    }
    CS.CSInstanceBase = CSInstanceBase;
})(CS || (CS = {}));

//# sourceMappingURL=cs-instance-base.js.map
